import Swal from "sweetalert2";

export const errorMsg = (title, text) =>
  Swal.fire({
    icon: "error",
    title,
    text,
  });

export const success = (title, text) =>
  Swal.fire({
    icon: "success",
    title,
    text,
  });

export const confirmation = () =>
  Swal.fire({
    title: "Are you sure you want to delete?",
    text: "You won't be able to recover this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#2faf4d",
    cancelButtonColor: "#d33",
    confirmButtonText: "Delete",
  });
export const confirmScreenDelete = () =>
  Swal.fire({
    title: "Delete this screen?",
    html: `<div style="text-align: center">
             <p style="margin: 8px 0">Will stop all assigned campaigns, remove mobile and fixed locations links, and delete location history.</p>
           </div>`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Delete Screen",
    customClass: {
      htmlContainer: "text-left",
    },
  });
export const confirmCampaignDelete = () =>
  Swal.fire({
    title: "Delete this campaign?",
    html: `<div style="text-align: center">
             <p style="margin: 8px 0">Will immediately remove from all screens and stop playback everywhere.</p>
           </div>`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Delete Campaign",
  });
export const confirmVehicleDelete = () =>
  Swal.fire({
    title: "Delete this Mobile Location?",
    html: `<div style="text-align: center">
             <p style="margin: 8px 0">Will unlink all assigned screens and remove mobile location-specific content.</p>
           </div>`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Delete Mobile Location",
  });

export const confirmRestaurantDelete = () =>
  Swal.fire({
    title: "Delete this Fixed Location?",
    html: `<div style="text-align: center">
           <p style="margin: 8px 0">Will detach all linked screens and stop running campaigns.</p>
         </div>`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Delete Fixed Location",
  });

export const confirmMediaDelete = () =>
  Swal.fire({
    title: "Delete this infotainment video?",
    html: `<div style="text-align: center">
             <p style="margin: 8px 0">This will remove the video from all campaigns and it will no longer play on any screens.</p>
           </div>`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Delete Video",
  });
